import React, { useEffect } from "react";
import PaymentDashboardRoutes from "./PaymentDashboardRoutes";
import axios from "axios";
import { PaymentRoutes } from "../../../Contracts/Routes";
import { useBannerStore } from "../../../Store/Banner";
import { BannerType } from "../../../Contracts/Banner";

const PaymentAppDashboard: React.FC = () => {
  const { addBanner } = useBannerStore();

  useEffect(() => {
    axios.interceptors.response.use(
      response => response,
      async error => {
        if (error.response?.status === 500) {
          window.location.href = PaymentRoutes.INTERNAL_SERVER_ERROR;
        }
        if (error.response?.status === 401) {
          const isClientPortalRoute = window.location.pathname.startsWith(
            "/client-portal"
          );
          const redirect = isClientPortalRoute
            ? `${PaymentRoutes.SESSION_ENDED}?fromClientPortal=true`
            : PaymentRoutes.SESSION_ENDED;
          window.location.href = redirect;
        }
        if (error.response?.status === 400 || error.response?.status === 404) {
          addBanner({
            type: BannerType.Error,
            message: error.response.data?.description
          });
        }
        throw error;
      }
    );
  }, [addBanner]);
  return (
    <>
      <PaymentDashboardRoutes />
    </>
  );
};

export default PaymentAppDashboard;
